export const jobRequestsTableHeader = [
  {
    id: 'name',
    numeric: false,
    label: 'Name',
    disabled: true,
  },
  {
    id: 'phoneNumber',
    numeric: false,
    label: 'Phone Number',
    disabled: true,
  },
  {
    id: 'qualification',
    numeric: false,
    label: 'Qualification',
    disabled: true,
  },
  {
    id: 'preference',
    numeric: false,
    label: 'Preference',
    disabled: true,
  },
  {
    id: 'reference',
    numeric: false,
    label: 'Reference',
    disabled: true,
  },
  {
    id: 'mandal',
    numeric: false,
    label: 'Mandal',
    disabled: true,
  },
  {
    id: 'constituency',
    numeric: false,
    label: 'Constituency',
    disabled: true,
  },
  {
    id: 'action',
    numeric: false,
    label: 'Upload/Download Resume',
    disabled: true,
  },
];

export const jobRequestFields = [
  {
    fieldName: 'fileUpload',
    fieldTitle: 'Upload File',
    fieldType: 'upload',
  },
];
